var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"component-follow"},[_c('h6',[_vm._v("扫码关注“"+_vm._s(_vm.$route.meta.title)+"”公众号"),_c('br'),_vm._v("查看更多小样申领线报")]),_c('img',{staticClass:"qrcode",attrs:{"src":_vm.$route.meta.qrcode}})])}
var staticRenderFns = []

export { render, staticRenderFns }